<template>
  <section
    :id="element.Oid + '-element'"
    style="position: relative; z-index: 1000"
    :style="{
      width: `${element.startWidth * 100}%`,
      left: `${100 * (1 + element.startWidth) * element.startPosition - 100 * element.startWidth}%`,
      opacity: `${element.startOpacity}`,
    }"
    v-observe-visibility="visibilityChanged"
  >

    <audio ref="audio" v-bind="audioProps">
      <source :src="element.url" type="audio/mp3" />
    </audio>
    <div v-if="element.text" class="ql-editor" v-html="element.text" />
  </section>
</template>

<script>
// import Component from "../component_location"

export default {
  components: {},

  props: {
    element: { type: Object, default: () => {} },
    scaleFactor: { type: Number, default: 1 },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {
    visibilityChanged (isVisible) {
      const audioElement =  this.$refs.audio
      if(this.element.isBackground) {
        if(isVisible) {
          audioElement.play()
        } else {
          audioElement.pause()
        }
      }
      else if(this.element.videoControls) {
         audioElement.pause()
      }
    },
  },

  computed: {
    audioProps(){
      return {
        autoplay: this.element.isBackground ? 'autoplay' : undefined,
        controls: this.element.isBackground ? undefined : 'controls',
        loop: this.element.isBackground ? 'loop' : undefined
      }
    }
  },

  mounted() {
  },
};
</script>

<style></style>
